// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__86KRv","content":"styles_content__9My03","tableWrap":"styles_tableWrap__2bYUL"};